import classNames from 'classnames';

import { icon_arrow_left, icon_burger, icon_close_medium } from '@gn-audio/icons';

import { useFallbackTranslation } from '../../../utils/hooks';
import { BasketButton } from '../../Basket/BasketButton';
import { Button } from '../../Button/Button';
import { EcomOnly } from '../../EcomOnly/EcomOnly';
import { JabraIcon } from '../../JabraIcon/JabraIcon';
import { LogoLink } from '../../LogoLink/LogoLink';
import UipMenu from '../../UipMenu/UipMenu';
import { DISPLAY_VERSIONS } from '../MegaMenuConstants';
import { useHeaderNavigation } from '../providers';

import styles from '../MegaMenu.module.css';

type Props = {
  isNavigationTransparent?: boolean;
  showNavigation?: boolean;
};

export const MobileTopMenu = ({
  isNavigationTransparent,
  showNavigation,
}: Props): React.JSX.Element | null => {
  const { isMobileMenuOpen, activeItemId, onMobileMenuClick, onBackClick } = useHeaderNavigation();
  const { t } = useFallbackTranslation();

  const UipAndBasket = () => (
    <>
      <li className={styles.menuButton} key="uip-icon">
        <EcomOnly>
          <UipMenu />
        </EcomOnly>
      </li>
      <li className={styles.menuButton} key="basket">
        <BasketButton />
      </li>
    </>
  );

  return (
    <div className="w-full lg:hidden">
      {isMobileMenuOpen ? (
        showNavigation ? (
          <div
            className={`${
              isNavigationTransparent ? 'bg-transparent' : 'bg-white'
            } flex flex-1 items-center justify-between border-b-2 border-gray-100 px-3 py-2 lg:hidden ${
              DISPLAY_VERSIONS.MOBILE
            } topMenu`}
          >
            {activeItemId ? (
              <Button
                variant="quaternary"
                className="no-underline"
                linkUnderline={false}
                iconPlacement="left"
                size="m"
                icon={<JabraIcon className="size-4" Icon={icon_arrow_left} />}
                onClick={() => onBackClick?.()}
              >
                <span className="text-sm font-bold">{t('topmenu.GoBack')}</span>
              </Button>
            ) : (
              <LogoLink />
            )}
            <ul className="flex h-full justify-items-end">
              <UipAndBasket />
              <li className={classNames(styles.menuButton, 'w-[3rem]')}>
                <Button
                  variant="tertiary"
                  onClick={() => onMobileMenuClick?.()}
                  size="m"
                  aria-expanded="true"
                  icon={<JabraIcon className="h-4" Icon={icon_close_medium} />}
                  iconPlacement="right"
                />
              </li>
            </ul>
          </div>
        ) : null
      ) : (
        <div
          className={`${
            isNavigationTransparent ? 'bg-transparent' : 'bg-white'
          } flex flex-1 justify-between px-3 py-2 lg:hidden ${DISPLAY_VERSIONS.MOBILE} topMenu`}
        >
          <LogoLink />
          {showNavigation ? (
            <ul className="flex cursor-pointer items-center self-center">
              <UipAndBasket />
              <li onClick={() => onMobileMenuClick?.()} className={styles.menuButton}>
                <button
                  title={t('topmenu.Navigation')}
                  aria-label={t('topmenu.Navigation')}
                  aria-haspopup="menu"
                  aria-expanded="false"
                  className="btn-top-menu"
                >
                  <JabraIcon Icon={icon_burger} />
                </button>
              </li>
            </ul>
          ) : null}
        </div>
      )}
    </div>
  );
};
